<script>
import { authComputed } from '@state/helpers'
import Appmenu from './app-menu'

export default {
	components: { Appmenu },
	props: {
		isCondensed: {
			type: Boolean,
			default: false,
		},
		theme: {
			type: String,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
		width: { type: String, required: true },
		user: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		},
		data() {
			return {
			settings: {
				minScrollbarLength: 60,
			},
		}
	},
	computed: {
		...authComputed,
	},
	watch: {
		theme: function(newVal, oldVal) {
			if (newVal !== oldVal) {
				switch (newVal) {
					case 'dark':
						document.body.classList.add('left-side-menu-dark')
						document.body.classList.remove('left-side-menu-condensed')
						document.body.classList.remove('boxed-layout')
						break
					default:
						document.body.classList.remove('left-side-menu-dark')
						break
				}
			}
		},
		type: function(newVal, oldVal) {
			if (newVal !== oldVal) {
				switch (newVal) {
					case 'condensed':
						document.body.classList.add('left-side-menu-condensed')
						document.body.classList.remove('left-side-menu-dark')
						document.body.classList.remove('boxed-layout')
						break
					default:
						document.body.classList.remove('left-side-menu-condensed')
						break
				}
			}
		},
		width: function(newVal, oldVal) {
			if (newVal !== oldVal) {
				switch (newVal) {
					case 'boxed':
						document.body.classList.add('left-side-menu-condensed')
						document.body.classList.remove('left-side-menu-dark')
						document.body.classList.add('boxed-layout')
						break
					default:
						document.body.classList.remove('left-side-menu-condensed')
						document.body.classList.remove('boxed-layout')
						break
				}
			}
		},
	},
}
</script>
<template>	
<div class="left-side-menu"  id="leftsidebar" >
    <div class="media user-profile mt-2 mb-2">
        <img src="@assets/images/users/avatar-01.jpg" class="avatar-sm rounded-circle mr-2" alt="" />
        <img src="@assets/images/users/avatar-01.jpg" class="avatar-xs rounded-circle mr-2" alt="" />
        <div class="media-body" >
            <span class="pro-user-desc" style="line-height:40px"> {{user.Username}}</span>
        </div>
    </div>
    <div class="sidebar-content">
        <div id="sidebar-menu">
            <Appmenu />
        </div>
    </div>
</div>
</template>
<style lang="scss">
.slimscroll-menu {height: 100%;}
</style>